import styled, { css, keyframes } from 'styled-components'
import { colors } from '../../../Colors'

const extendFromRight = keyframes`
  0% {
    right: -390px;
  }
  100% {
    right: 0;
  }
`
const collapseToRight = keyframes`
  0% {
    right: 0;
  }
  100% {
    right: -390px;
  }
`

export const DropdownContainerWrapper = styled.div<{ isShow: boolean }>`
    width: 390px;
    position: fixed;
    right: 0;
    top: initial;
    bottom: 0;
    z-index: 9;
    height: 100%;
    animation: ${({ isShow }) => (isShow ? extendFromRight : collapseToRight)} 0.25s ease-in-out forwards;
    @media (max-width: 992px) {
        width: 100%;
    }
`

export const DropdownContainerBodyWrapper = styled.div<{ isShow: boolean; isMobile: boolean }>`
    background-color: #fff;
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.16);
    height: 100%;
    display: flex;
    flex-direction: column;
    ${({ isMobile }) => {
        if (isMobile) {
            return ''
        }
        return css<{ isShow: boolean }>`
            will-change: transform;
            overflow: hidden;
        `
    }}
`

export const HeaderTitle = styled.div`
    color: #000;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    width: 100%;
    padding: 12px;
`

export const NotifyIcon = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: ${colors.primary[95]};
`

export const TitleContent = styled.div`
    width: calc(100% - 102px);
    margin: 0 16px;
`

export const CloseIcon = styled.span`
    float: right;
    cursor: pointer;
    &:hover {
        svg {
            path {
                fill: #333;
            }
        }
    }
`

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99;
`

export const NotifyBadge = styled.span`
    top: 0;
    right: 0;
    background: #dc362e;
    color: #ffffff;
    width: fit-content;
    padding: 0;
    min-width: 14px;
    height: 14px;
    border-radius: 8px;
    font-size: 9px;
    position: absolute;
    text-align: center;
    z-index: 5;

    &&&& svg {
        width: 7px;
        height: 7px;
        fill: #f7941d;
        position: absolute;
        top: 0;
        left: 5px;
    }
`
